export enum FeatureDiscoveryElement {
  PATTERNLIST = 'PATTERNLIST',
  ACTIONS = 'ACTIONS',
  HOME = 'HOME',
  FREE_LAYOUT = 'FREE_LAYOUT',
}
